import { Injectable, inject, signal } from '@angular/core';
import { ApiSysService } from '@core/api/api-sys.service';
import { AuthService } from '@core/auth/auth.service';
import { throwApiError } from '@core/error';
import { NetworkCatalogItem } from './models/infrastructure-catalog.model';

/**
 * Reference-data loader for networks (guide §6), mirroring InfrastructureCatalogService.
 */
@Injectable({ providedIn: 'root' })
export class NetworkCatalogService {
    private readonly apiSys = inject(ApiSysService);
    private readonly auth = inject(AuthService);

    private readonly _networks = signal<NetworkCatalogItem[]>([]);
    readonly networks = this._networks.asReadonly();

    async loadForCurrentUser(translations?: any): Promise<NetworkCatalogItem[]> {
        const { data, error } = await this.apiSys.getNetworksUser(this.auth.getToken());
        if (error) throwApiError(error, translations, 'UPDATE_NETWORK_ERROR');

        this._networks.set(data ?? []);
        return this._networks();
    }
}
